import { container } from "tsyringe";
import { EditorSettingsService } from "./designs/settings/EditorSettingsService";
import { CustomerService } from "./designs/customers/CustomerService";
import { ICustomerService } from "$src/domain/customers/ICustomerService";
import { ServiceTokens } from "$src/domain/ServiceTokens";
import { IUserService } from "$src/domain/users/IUserService";
import { UserService } from "./users/UserService";
import { ISearchService } from "$src/domain/searches/ISearchService";
import { SearchService } from "./searches/SearchService";
import { GetCustomersByRecentProjectsToken, GetCustomersByRecentProjects } from "./customers/queries/GetCustomersByRecentProjects";
import { GetProjectsByCustomerId, GetProjectsByCustomerIdToken } from "./customers/queries/GetProjectsByCustomerId";
import { GetCustomersById, GetCustomersByIdToken } from "./customers/queries/GetCustomerById";
import { GetDocumentsByProjectId, GetDocumentsByProjectIdToken } from "./projects/sub/documents/queries/GetDocumentsByProjectId";
import { GetDocumentFileById, GetDocumentFileByIdToken } from "./projects/sub/documents/queries/GetDocumentFileById";
import { CreateDocument, CreateDocumentToken } from "./projects/sub/documents/commands/CreateDocument";
import { UpdateDocument, UpdateDocumentToken } from "./projects/sub/documents/commands/UpdateDocument";
import { DeleteDocument, DeleteDocumentToken } from "./projects/sub/documents/commands/DeleteDocument";
import { GetDocumentById, GetDocumentByIdToken } from "./projects/sub/documents/queries/GetDocumentById";
import { GetProjectById, GetProjectByIdToken } from "./projects/queries/GetProjectById";
import { GetCustomerByProjectId, GetCustomerByProjectIdToken } from "./projects/queries/GetCustomerByProjectId";
import { RequestDraft, RequestDraftToken } from "./projects/sub/drafts/commands/RequestDraft";
import { TakeOverDraft, TakeOverDraftToken } from "./projects/sub/drafts/commands/TakeOverDraft";
import { GetDraft, GetDraftToken } from "./projects/sub/drafts/commands/GetDraft";
import { PatchDraft, PatchDraftToken } from "./projects/sub/drafts/commands/PatchDraft";
import { OverrideDraft, OverrideDraftToken } from "./projects/sub/drafts/commands/OverrideDraft";
import { DeleteDraft, DeleteDraftToken } from "./projects/sub/drafts/commands/DeleteDraft";
import { PublishDraft, PublishDraftToken } from "./projects/sub/drafts/commands/PublishDraft";
import { GetDeliveryTypes, GetDeliveryTypesToken } from "./projects/sub/deliveries/queries/GetDeliveryTypes";
import { GetLocalitiesByName, GetLocalitiesByNameToken } from "./map/queries/GetLocalitiesByName";
import { GetLocalitiesByPostalCode, GetLocalitiesByPostalCodeToken } from "./map/queries/GetLocalitiesByPostalCode";
import { GetCountries, GetCountriesToken } from "./map/queries/GetCountries";
import { GetRoad, GetRoadToken } from "./map/commands/GetRoad";
import { GetStoreById, GetStoreByIdToken } from "./directory/stores/queries/GetStoreById";
import { SearchCustomers, SearchCustomersToken } from "./customers/queries/SearchCustomers";
import { GetFolders, GetFolderToken } from "./customers/queries/GetFolders";
import { CreateProject, CreateProjectToken } from "./projects/commands/CreateProject";
import { GetCustomerTypes, GetCustomerTypesToken } from "./customers/queries/GetCustomerTypes";
import { CheckCustomerHasInvoices, CheckCustomerHasInvoicesToken } from "./customers/queries/CheckCustomerHasInvoices";
import { UpdateCustomer, UpdateCustomerToken } from "./customers/commands/UpdateCustomer";
import { OrderProject, OrderProjectToken } from "./projects/commands/OrderProject";
import { ComputeGeocode, GeocodeToken } from "./map/commands/ComputeGeocode";
import { ComputeRoadFromPoints, ComputeRoadFromPointsToken } from "./map/commands/ComputeRoadFromPoints";
import { CreateCustomer, CreateCustomerToken } from "./customers/commands/CreateCustomer";
import { GetProjectTypes, GetProjectTypesToken } from "./customers/queries/GetProjectTypes";

container.register<EditorSettingsService>("EditorSettingsService", { useClass: EditorSettingsService });
container.register<IUserService>(ServiceTokens.UserService, { useClass: UserService });
container.register<ICustomerService>(ServiceTokens.CustomerService, { useClass: CustomerService });
container.register<ISearchService>(ServiceTokens.SearchService, { useClass: SearchService });

//customer
container.register(GetCustomersByIdToken, {useClass: GetCustomersById });
container.register(GetCustomersByRecentProjectsToken, {useClass: GetCustomersByRecentProjects });
container.register(GetProjectsByCustomerIdToken, {useClass: GetProjectsByCustomerId });
container.register(SearchCustomersToken, {useClass: SearchCustomers });
container.register(GetFolderToken, {useClass: GetFolders });
container.register(GetCustomerTypesToken, {useClass: GetCustomerTypes });
container.register(GetProjectTypesToken, {useClass: GetProjectTypes });
container.register(CreateCustomerToken, {useClass: CreateCustomer });
container.register(UpdateCustomerToken, {useClass: UpdateCustomer });
container.register(CheckCustomerHasInvoicesToken, {useClass: CheckCustomerHasInvoices });

//store
container.register(GetStoreByIdToken, {useClass: GetStoreById });

//project
container.register(GetProjectByIdToken, {useClass: GetProjectById });
container.register(GetCustomerByProjectIdToken, {useClass: GetCustomerByProjectId });
container.register(CreateProjectToken, {useClass: CreateProject });
container.register(OrderProjectToken, {useClass: OrderProject });

//project / draft
container.register(RequestDraftToken, {useClass: RequestDraft });
container.register(TakeOverDraftToken, {useClass: TakeOverDraft });
container.register(GetDraftToken, {useClass: GetDraft });
container.register(PatchDraftToken, {useClass: PatchDraft });
container.register(OverrideDraftToken, {useClass: OverrideDraft });
container.register(DeleteDraftToken, {useClass: DeleteDraft });
container.register(PublishDraftToken, {useClass: PublishDraft });

//project / document
container.register(GetDocumentsByProjectIdToken, {useClass: GetDocumentsByProjectId });
container.register(GetDocumentByIdToken, {useClass: GetDocumentById });
container.register(GetDocumentFileByIdToken, {useClass: GetDocumentFileById });
container.register(CreateDocumentToken, {useClass: CreateDocument });
container.register(UpdateDocumentToken, {useClass: UpdateDocument });
container.register(DeleteDocumentToken, {useClass: DeleteDocument });

//project / deliveries
container.register(GetDeliveryTypesToken, {useClass: GetDeliveryTypes });

//map / localityes
container.register(GetCountriesToken, {useClass: GetCountries });
container.register(GetLocalitiesByNameToken, {useClass: GetLocalitiesByName });
container.register(GetLocalitiesByPostalCodeToken, {useClass: GetLocalitiesByPostalCode });
container.register(GeocodeToken, {useClass: ComputeGeocode });
container.register(ComputeRoadFromPointsToken, {useClass: ComputeRoadFromPoints });
container.register(GetRoadToken, {useClass: GetRoad });